export interface Project {
  id: number;
  slug: string;
  title: string;
  subtitle?: string;
  description: string;
  contentFile?: string;
  categories: ('automation' | 'data' | 'ar' | 'touch' | 'branding' | 'news' | 'sports')[];
  technologies: string[];
  image?: string;
  media?: string[];
  liveUrl?: string;
  githubUrl?: string;
  year?: string;
  team?: string;
  sources?: Array<{
    title: string;
    url: string;
  }>;
}

export const projectsData: Project[] = [
  {
    id: 1,
    slug: 'servus-tv-news-production',
    title: 'News Production',
    subtitle: 'Servus-TV',
    description: 'Welt supported ServusTV Deutschland with newsroom integration and video wall technology.',
    contentFile: '/content/projects/servustv-2023.md',
    categories: ['automation', 'news'],
    technologies: ['Mosart', 'Multiplay', 'Pilot Edge', 'Octopus Newsroom', 'TypeScript'],
    liveUrl: 'https://www.youtube.com/watch?v=wBT6ExTdvTk',
    image: '/images/projects/welt-produces-servuts-tv-2023/image2.jpeg',
    year: '2023',
    team: 'Welt/Axel Springer SE Production Team',
    sources: [
      {
        title: 'ServusTV Deutschland Official Website',
        url: 'https://www.servustv.com/de'
      }
    ]
  },
  {
    id: 2,
    slug: 'sky-sports-f1-touchscreen',
    title: ' Sports Touch',
    subtitle: 'Sky Sport News HD',
    description: 'Interactive F1 analytics application with real-time OPTA data integration and 3D visualizations for broadcast anchors.',
    contentFile: '/content/projects/sky-f1-touchscreen-2015.md',
    categories: ['touch', 'data', 'sports'],
    technologies: ['Vizrt', 'Touch Interface', 'OPTA Data', 'Cinema 4D', 'Real-time Graphics', '3D Animation'],
    liveUrl: 'https://youtu.be/BuqvoSR5Gfc',
    image: '/images/projects/sky-f1-touchscreen-2015/f1-touchscreen-main.jpg',
    year: '2015',
    team: 'Sky Sports News HD',
    sources: [
      {
        title: 'Sky Sports F1 Coverage',
        url: 'https://www.skysports.com/f1'
      },
      {
        title: 'OPTA Sports Data Solutions',
        url: 'https://www.statsperform.com/opta/'
      },
      {
        title: 'Vizrt Broadcast Graphics',
        url: 'https://www.vizrt.com'
      }
    ]
  },
  {
    id: 3,
    slug: 'tv-azteca-world-cup-2006',
    title: 'World Cup Graphics',
    subtitle: 'TV Azteca',
    description: 'Comprehensive Vizrt graphics package implementation for TV Azteca\'s Germany 2006 World Cup coverage.',
    contentFile: '/content/projects/tv-azteca-worldcup-2006.md',
    categories: ['branding', 'sports'],
    technologies: ['Viz Artist', 'Viz Content Pilot', 'Viz Virtual Studio', 'Viz Arena', 'Viz Engine', 'HD Broadcasting'],
    image: '/images/projects/tv-azteca-worldcup-2006/image2.jpg',
media: [
      '/images/projects/tv-azteca-worldcup-2006/image1.jpg',
      '/images/projects/tv-azteca-worldcup-2006/image2.jpg',
      '/images/projects/tv-azteca-worldcup-2006/image3.jpg',
      '/images/projects/tv-azteca-worldcup-2006/image4.jpg',
      '/images/projects/tv-azteca-worldcup-2006/image5.jpg',
      '/images/projects/tv-azteca-worldcup-2006/image6.jpg',
      '/images/projects/tv-azteca-worldcup-2006/image7.jpg'
    ],    
    year: '2006',
    team: 'Vizrt Creative Team New York',
    sources: [
      {
        title: 'Behance - TV Azteca - World Cup 2006 Package (Jonathan Watson)',
        url: 'https://www.behance.net/gallery/6182831/TV-Azteca-World-Cup-2006-Package'
      },
      {
        title: 'TV Azteca Official Site',
        url: 'https://www.tvazteca.com'
      },
      {
        title: 'produ.com - Alemania 2006: TV Azteca transmitirá 33 partidos en alta definición',
        url: 'https://www.produ.com/television/noticias/alemania-2006-tv-azteca-transmitira-33-partidos-en-alta-definicion/'
      }
    ]
  },
  {
    id: 4,
    slug: 'sky-sports-news-redesign',
    title: 'Redesign',
    subtitle: 'Sky Sport News HD',
    description: 'Graphics package integration and automation for Sky Deutschland\'s new look aligning with BSkyB identity.',
    contentFile: '/content/projects/sky-sports-redesign-2016.md',
    categories: ['automation', 'sports', 'news'],
    technologies: ['Automation', 'Ticker'],
    image: '/images/projects/sky-sports-redesign-2016/SKY2.jpg',
    year: '2016',
    team: 'Sky Deutschland & Reality Check Systems'
  },
  {
    id: 5,
    slug: 'cnn-elections-touchscreen',
    title: 'Election Touch',
    subtitle: 'CNN',
    description: 'Interactive touch screen system for U.S. election coverage showing balance of power scenarios.',
    contentFile: '/content/projects/cnn-elections-2006.md',
    categories: ['news', 'touch', 'data'],
    technologies: ['Touch Screen', 'Data Integration', 'Electoral Data'],
    liveUrl: 'https://www.youtube.com/watch?v=Ph1tBHqAjew',
    image: '/images/projects/cnn-elections-2006/cnn.jpg',    
    year: '2006',
    team: 'Vizrt Creative Team New York'
  },
  {
    id: 6,
    slug: 'sky-sport-cube-studios',
    title: 'Cube Studios',
    subtitle: 'Sky Sport',
    description: 'State-of-the-art 4600 m² studio complex with massive LED walls driven by Vizrt automation systems.',
    contentFile: '/content/projects/sky-sport-cube-2018.md',
    categories: ['automation', 'sports'],
    technologies: ['Studio', 'Automation', 'Viz Multiplay', 'Automation'],
    liveUrl: 'https://www.youtube.com/watch?v=N15vMOLEZ_U',
    image: '/images/projects/sky-sport-cube-2018/Untitled.png',
    year: '2018',
    team: 'Sky Sports Germany Munich',
    sources: [
      {
        title: 'Sky Sport Cube - Europe\'s Most Modern Studio',
        url: 'https://www.sky.de'
      },
      {
        title: 'Vizrt Studio Automation Solutions',
        url: 'https://www.vizrt.com/products/viz-multiplay'
      }
    ]
  },
  {
    id: 7,
    slug: 'todo-noticias-rebranding',
    title: 'Rebranding',
    subtitle: 'Todo Noticias',
    description: 'Complete rebranding project for TN news channel with "Todos Nosotros" campaign and visual identity.',
    contentFile: '/content/projects/todo-noticias-rebranding-2012.md',
    categories: ['branding', 'news'],
    technologies: ['viz trio', 'viz artist', 'datapool', 'transition logic'],
    image: '/images/projects/todo-noticias-rebranding-2012/tn.png',
    media: [
      '/images/projects/todo-noticias-rebranding-2012/tn_rebrand_2012_1.jpg',
      '/images/projects/todo-noticias-rebranding-2012/tn_rebrand_2012_2.jpg',
      '/images/projects/todo-noticias-rebranding-2012/tn_rebrand_2012_3.jpg',
      '/images/projects/todo-noticias-rebranding-2012/tn_rebrand_2012_4.jpg',
      '/images/projects/todo-noticias-rebranding-2012/tn_rebrand_2012_5.jpg',
      '/images/projects/todo-noticias-rebranding-2012/tn_rebrand_2012_6.jpg',
      '/images/projects/todo-noticias-rebranding-2012/tn_rebrand_2012_7.jpg',
      '/images/projects/todo-noticias-rebranding-2012/tn_rebrand_2012_8.jpg',
      '/images/projects/todo-noticias-rebranding-2012/tn_rebrand_2012_9.jpg',
      '/images/projects/todo-noticias-rebranding-2012/tn_rebrand_2012_10.jpg',
      '/images/projects/todo-noticias-rebranding-2012/tn_rebrand_2012_11.jpg',
      '/images/projects/todo-noticias-rebranding-2012/tn_rebrand_2012_12.jpg',
      '/images/projects/todo-noticias-rebranding-2012/tn_rebrand_2012_13.jpg',
      '/images/projects/todo-noticias-rebranding-2012/tn_rebrand_2012_14.jpg',
      '/images/projects/todo-noticias-rebranding-2012/tn_rebrand_2012_15.jpg',
      '/images/projects/todo-noticias-rebranding-2012/tn_rebrand_2012_16.jpg',
      '/images/projects/todo-noticias-rebranding-2012/tn_rebrand_2012_17.jpg',
      '/images/projects/todo-noticias-rebranding-2012/tn_rebrand_2012_18.jpg',
      '/images/projects/todo-noticias-rebranding-2012/tn_rebrand_2012_19.jpg',
      '/images/projects/todo-noticias-rebranding-2012/tn_rebrand_2012_20.jpg'
    ],
    year: '2012',
    sources: [
      {
        title: 'Gizmo Studios',
        url: 'http://www.gizmosite.tv/'
      },
      {
        title: 'TN - Todos Nosotros Project on Behance',
        url: 'https://www.behance.net/gallery/23994883/TN-Todos-Nosotros'
      }
    ]
  },
  {
    id: 8,
    slug: 'artear-tn-news-graphics',
    title: 'Visual Identity',
    subtitle: 'Todo Noticias',
    description: 'Graphics upgrade for Argentina\'s TN pay-TV news channel using Vizrt technology and Gizmo Studios collaboration.',
    contentFile: '/content/projects/artear-tn-rebranding-2006.md',
    categories: ['branding', 'news'],
    technologies: ['Viz Artist', 'Viz Trio', 'Real-time Graphics', 'Character Generation', '3D Animation'],
    liveUrl: 'https://www.youtube.com/watch?v=tDOo_RdN8kM',
    image: '/images/projects/artear-tn-rebranding-2006/tn.png',
    year: '2006',
    media: [
      '/images/projects/artear-tn-rebranding-2006/zocalo.png',
      '/images/projects/artear-tn-rebranding-2006/tn.png',
      '/images/projects/artear-tn-rebranding-2006/titulos.png',
      '/images/projects/artear-tn-rebranding-2006/ots.png',      
      '/images/projects/artear-tn-rebranding-2006/zocalo2.png',
      '/images/projects/artear-tn-rebranding-2006/zocaloots.png',      
      '/images/projects/artear-tn-rebranding-2006/quinela.png',
      '/images/projects/artear-tn-rebranding-2006/monedas.png',            
      '/images/projects/artear-tn-rebranding-2006/urgente.png',
      '/images/projects/artear-tn-rebranding-2006/zocalourgente.png',
      '/images/projects/artear-tn-rebranding-2006/zocalourgente2.png',
      '/images/projects/artear-tn-rebranding-2006/duplex.png',
      '/images/projects/artear-tn-rebranding-2006/ventas.png',
      '/images/projects/artear-tn-rebranding-2006/duplex2.png',
      '/images/projects/artear-tn-rebranding-2006/eninstantes.png',
      '/images/projects/artear-tn-rebranding-2006/venta2.png',
      '/images/projects/artear-tn-rebranding-2006/pronostico.png',                                                
    ],    
    team: 'Gizmo Studios, Artear CAE, Vizrt Latin America',
    sources: [
      {
        title: 'Adlatina - Gizmo renovó la imagen de TN',
        url: 'https://www.adlatina.com/articulo.php?slug=/publicidad/gizmo-renov%C3%B3-la-imagen-de-tn'
      },
      {
        title: 'Tv y Video: Artear Canal 13 Graphics System',
        url: 'https://www.tvyvideo.com/en/2006101811975/news/technology/artear-canal-13-acquires-new-system-for-creating-graphics-and-gc.'
      },
      {
        title: 'Gizmo Studios',
        url: 'https://gizmosite.tv/'
      }
    ]    
  },
  {
    id: 9,
    slug: 'sports-graphics-masterclass',
    title: 'SVG Spotlight',
    subtitle: 'Masterclass',
    description: 'The Sports Graphics Spotlight brought together experts from DAZN, Sky Germany, and TV 2 Norway for a deep dive into how graphics are shaping the future of live sports. ',
    contentFile: '/content/projects/sports-graphics-spotlight-2021.md',
    categories: ['data', 'sports', 'ar'],
    technologies: ['','Sports Data', 'Broadcast'],
    liveUrl: 'https://www.youtube.com/watch?v=tF0a-o_OPIo',
    image: '/images/projects/sports-graphics-spotlight-2021/sports_graphics_spotlight_2021.jpg',
    year: '2021',
    team: 'DAZN, Sky Germany, TV2 Norway'
  },
  {
    id: 10,
    slug: 'sky-sports-augmented-reality',
    title: 'Augmented Reality',
    subtitle: 'Sky Sport',
    description: 'Pioneering AR technology implementation for Sky Sports using Vizrt\'s advanced augmented reality systems.',
    contentFile: '/content/projects/sky-sports-augmented-reality-2019.md',
    categories: ['ar', 'sports'],
    technologies: ['Augmented Reality', 'Vizrt AR', 'Real-time Rendering', 'Virtual Graphics', 'Live Broadcasting'],
    image: '/images/projects/sky-sports-augmented-reality-2019/sky-sports-augmented-reality-2019.jpg',
    liveUrl: 'https://youtu.be/Y2CLLpSl-zE',
    year: '2019',
    team: 'Sky Sports & Vizrt'
  },
  {
    id: 11,
    slug: 'aws-bundesliga-match-facts',
    title: 'AWS Match Facts',
    subtitle: 'Bundesliga',
    description: 'Bundesliga took a big step in sports broadcasting by using AWS cloud to turn complex match data into clear, live graphics on screen',
    contentFile: '/content/projects/aws-bundesliga-match-facts-2020.md',
    categories: ['data', 'sports'],
    technologies: ['AWS', 'Opta', 'Mongo', 'Vizrt'],
    image: '/images/projects/aws-bundesliga-match-facts-2020/skysport_de-bundesliga-match-facts.jpg',
    year: '2020',
    team: 'AWS & Bundesliga Broadcasting'
  },
  {
    id: 12,
    slug: 'welt-us-elections',
    title: 'US Elections',
    subtitle: 'Welt',
    description: 'High-tech studio brings elections to life with AR, immersive visuals, and real-time data',
    contentFile: '/content/projects/welt-us-elections-2024.md',
    categories: ['news', 'data'],
    technologies: ['Flowics', 'Ncam', 'Election Data', 'Vizrt'],
    image: '/images/projects/welt-us-elections-2024/intro.jpg',
    year: '2024',
    team: 'Welt Technology, V-Sion',    
    media: [
      '/images/projects/welt-us-elections-2024/Election_2024_welt_1.jpg',
      '/images/projects/welt-us-elections-2024/Election_2024_welt_2.jpg',
      '/images/projects/welt-us-elections-2024/Election_2024_welt_3.jpg',
      '/images/projects/welt-us-elections-2024/Election_2024_welt_4.jpg',
      '/images/projects/welt-us-elections-2024/Election_2024_welt_5.jpg',
      '/images/projects/welt-us-elections-2024/Election_2024_welt_6.jpg',
      '/images/projects/welt-us-elections-2024/Election_2024_welt_8.jpg',
      '/images/projects/welt-us-elections-2024/Election_2024_welt_10.jpg'
    ],
    sources: [
      {
        title: 'Vizrt: Meet the media tech behind the 2024 US Election',
        url: 'https://www.vizrt.com/community/blog/meet-the-media-tech-behind-the-2024-us-election/'
      },
      {
        title: 'V-Sion Creative Agency',
        url: 'https://www.v-sion.de/'
      }      
    ]    
  }
];